import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { IdentificationSection } from './components/IdentificationSection';
import { RevelationSection } from './components/RevelationSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '26274290175524410');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-cream font-body text-warm-dark selection:bg-sage/30 selection:text-olive-gold" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <IdentificationSection data-id="element-3" />
        <RevelationSection data-id="element-4" />
        <WhatYouGetSection data-id="element-5" />
        <PricingSection data-id="element-6" />
      </main>

      <footer className="bg-warm-dark text-cream/60 py-12 text-center text-sm" data-id="element-7">
        <div className="max-w-4xl mx-auto px-6" data-id="element-8">
          <p className="mb-4" data-id="element-9">
            © {new Date().getFullYear()} Hormonal Sovereignty. All rights
            reserved.
          </p>
          <p className="text-xs opacity-60 max-w-2xl mx-auto leading-relaxed" data-id="element-10">
            Disclaimer: The information provided is for educational purposes
            only and is not intended as a substitute for advice from your
            physician or other health care professional.
          </p>
        </div>
      </footer>
    </div>;
}